import { render, staticRenderFns } from "./NewVenueUserModal.vue?vue&type=template&id=08f82372&scoped=true&"
import script from "./NewVenueUserModal.vue?vue&type=script&lang=js&"
export * from "./NewVenueUserModal.vue?vue&type=script&lang=js&"
import style0 from "./NewVenueUserModal.vue?vue&type=style&index=0&id=08f82372&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f82372",
  null
  
)

export default component.exports